import { findMessage } from '../../..';

const azMessages = {
	az: {
		Yes: 'Bəli',
		No: 'Xeyr',
		Cancel: 'Ləğv et',
		Clear: 'Sil',
		Done: 'Oldu',
		Loading: 'Yüklənir...',
		Select: 'Seç...',
		Search: 'Axtar',
		Back: 'Geri',
		OK: 'Oldu',
		'dxCollectionWidget-noDataText': 'Göstərmək üçün məlumat yoxdur',
		'validation-required': 'Məcburi',
		'validation-required-formatted': '{0} zəruri',
		'validation-numeric': 'Dəyər rəqəm olmalıdır',
		'validation-numeric-formatted': '{0} bir sayı olmalı',
		'validation-range': 'Dəyər diapazondan kənarda',
		'validation-range-formatted': '{0} əhatə dairəsindən kənarda',
		'validation-stringLength': 'Dəyərin uzunluğu düzgün deyil',
		'validation-stringLength-formatted': '{0} uzunluğu düzgün deyil',
		'validation-custom': 'Dəyər etibarsızdır',
		'validation-custom-formatted': '{0} etibarsızdır',
		'validation-compare': 'Dəyərlər uyğun gəlmir',
		'validation-compare-formatted': '{0} uyğun gəlmir',
		'validation-pattern': 'Dəyər modelə uyğun gəlmir',
		'validation-pattern-formatted': '{0} naxışa uyğun gəlmir',
		'validation-email': 'E-poçt yanlışdır',
		'validation-email-formatted': '{0} etibarsızdır',
		'validation-mask': 'Dəyər etibarsızdır',
		'dxLookup-searchPlaceholder': 'Minimum simvol sayı: {0}',
		'dxList-pullingDownText': 'Yeniləmək üçün aşağı çəkin...',
		'dxList-pulledDownText': 'Yenilemek için bırakın...',
		'dxList-refreshingText': 'Yenilənir...',
		'dxList-pageLoadingText': 'Yüklənir...',
		'dxList-nextButtonText': 'Daha çox',
		'dxList-selectAll': 'Hamısını seç',
		'dxListEditDecorator-delete': 'Silin',
		'dxListEditDecorator-more': 'Daha çox',
		'dxScrollView-pullingDownText': 'Yeniləmək üçün aşağı çəkin...',
		'dxScrollView-pulledDownText': 'Yeniləmək üçün buraxın...',
		'dxScrollView-refreshingText': 'Yenilənir...',
		'dxScrollView-reachBottomText': 'Yüklənir...',
		'dxDateBox-simulatedDataPickerTitleTime': 'Vaxt seçin',
		'dxDateBox-simulatedDataPickerTitleDate': 'Tarixi seçin',
		'dxDateBox-simulatedDataPickerTitleDateTime': 'Tarix və vaxtı seçin',
		'dxDateBox-validation-datetime': 'Dəyər tarix və ya vaxt olmalıdır',
		'dxFileUploader-selectFile': 'Fayl seçin',
		'dxFileUploader-dropFile': 'və ya faylı bura buraxın',
		'dxFileUploader-bytes': 'bytes',
		'dxFileUploader-kb': 'kb',
		'dxFileUploader-Mb': 'Mb',
		'dxFileUploader-Gb': 'Gb',
		'dxFileUploader-upload': 'Yüklənir',
		'dxFileUploader-uploaded': 'Yüklənmişdir',
		'dxFileUploader-readyToUpload': 'Quraşdırmağa hazırdır',
		'dxFileUploader-uploadAbortedMessage': 'Yükləmə ləğv edildi',
		'dxFileUploader-uploadFailedMessage': 'Quraşdırma uğursuz oldu',
		'dxFileUploader-invalidFileExtension': 'Fayl növünə icazə verilmir',
		'dxFileUploader-invalidMaxFileSize': 'Fayl çox böyükdür',
		'dxFileUploader-invalidMinFileSize': 'Fayl çox kiçikdir',
		'dxRangeSlider-ariaFrom': 'From',
		'dxRangeSlider-ariaTill': 'Çox',
		'dxSwitch-switchedOnText': 'Açıq',
		'dxSwitch-switchedOffText': 'Əlaqədar',
		'dxForm-optionalMark': 'isteğe bağlıdır',
		'dxForm-requiredMessage': '{0} zəruri',
		'dxNumberBox-invalidValueMessage': 'Dəyər rəqəm olmalıdır',
		'dxNumberBox-noDataText': 'Məlumat yoxdur',
		'dxDataGrid-columnChooserTitle': 'Sütun Seçici',
		'dxDataGrid-columnChooserEmptyText': 'Sütunu gizlətmək üçün bura çəkin',
		'dxDataGrid-groupContinuesMessage': 'Növbəti səhifədə davam edir',
		'dxDataGrid-groupContinuedMessage': 'Əvvəlki səhifədən davam edin',
		'dxDataGrid-groupHeaderText': 'Bu Sütun üzrə Qruplaşdırın',
		'dxDataGrid-ungroupHeaderText': 'Qrupu Sil',
		'dxDataGrid-ungroupAllText': 'Bütün Qrupları Sil',
		'dxDataGrid-editingEditRow': 'Redaktə et',
		'dxDataGrid-editingSaveRowChanges': 'Yadda saxla',
		'dxDataGrid-editingCancelRowChanges': 'Ləğv et',
		'dxDataGrid-editingDeleteRow': 'Sil',
		'dxDataGrid-editingUndeleteRow': 'Silinmə',
		'dxDataGrid-editingConfirmDeleteMessage': 'Bu qeydi silmək istədiyinizə əminsiniz?',
		'dxDataGrid-validationCancelChanges': 'Dəyişiklikləri ləğv edin',
		'dxDataGrid-groupPanelEmptyText':
			'Sütun başlığını bu sütuna görə qruplaşdırmaq üçün buraya sürükləyin',
		'dxDataGrid-noDataText': 'Məlumat yoxdur',
		'dxDataGrid-searchPanelPlaceholder': 'Axtarış...',
		'dxDataGrid-filterRowShowAllText': '(Hamısı)',
		'dxDataGrid-filterRowResetOperationText': findMessage.get('100888'),
		'dxDataGrid-filterRowOperationEquals': findMessage.get('101711'),
		'dxDataGrid-filterRowOperationNotEquals': findMessage.get('101712'),
		'dxDataGrid-filterRowOperationLess': findMessage.get('101715'),
		'dxDataGrid-filterRowOperationLessOrEquals': findMessage.get('101716'),
		'dxDataGrid-filterRowOperationGreater': findMessage.get('101713'),
		'dxDataGrid-filterRowOperationGreaterOrEquals': findMessage.get('101714'),
		'dxDataGrid-filterRowOperationStartsWith': findMessage.get('101720'),
		'dxDataGrid-filterRowOperationContains': findMessage.get('101718'),
		'dxDataGrid-filterRowOperationNotContains': findMessage.get('101719'),
		'dxDataGrid-filterRowOperationEndsWith': findMessage.get('101721'),
		'dxDataGrid-filterRowOperationBetween': 'Arasında',
		'dxDataGrid-filterRowOperationBetweenStartText': 'Başlamaq',
		'dxDataGrid-filterRowOperationBetweenEndText': 'Bitir',
		'dxDataGrid-applyFilterText': 'Filtr tətbiq edin',
		'dxDataGrid-trueText': 'Bəli',
		'dxDataGrid-falseText': 'Yox',
		'dxDataGrid-sortingAscendingText': findMessage.get('101723'),
		'dxDataGrid-sortingDescendingText': findMessage.get('101724'),
		'dxDataGrid-sortingClearText': 'Düzgün düzəlişi təmizlə',
		'dxDataGrid-editingSaveAllChanges': 'Dəyişiklikləri yadda saxla',
		'dxDataGrid-editingCancelAllChanges': 'Dəyişiklikləri ləğv edin',
		'dxDataGrid-editingAddRow': 'Sıra əlavə edin',
		'dxDataGrid-summaryMin': 'Min: {0}',
		'dxDataGrid-summaryMinOtherColumn': '{1} min: {0}',
		'dxDataGrid-summaryMax': 'Max: {0}',
		'dxDataGrid-summaryMaxOtherColumn': '{1} max: {0}',
		'dxDataGrid-summaryAvg': 'Ort: {0}',
		'dxDataGrid-summaryAvgOtherColumn': '{1} ortalaması: {0}',
		'dxDataGrid-summarySum': 'Top: {0}',
		'dxDataGrid-summarySumOtherColumn': '{1} ümumi: {0}',
		'dxDataGrid-summaryCount': 'Ümumi: {0}',
		'dxDataGrid-columnFixingFix': 'Pin',
		'dxDataGrid-columnFixingUnfix': 'Həll et',
		'dxDataGrid-columnFixingLeftPosition': 'Sola',
		'dxDataGrid-columnFixingRightPosition': 'Sağa',
		'dxDataGrid-exportTo': 'İxrac',
		'dxDataGrid-exportToExcel': 'Excel faylına ixrac edin',
		'dxDataGrid-exporting': 'İxrac...',
		'dxDataGrid-excelFormat': 'Excel faylı',
		'dxDataGrid-selectedRows': 'Seçilmiş sıralar',
		'dxDataGrid-exportSelectedRows': 'Seçilmiş sətirləri köçürün',
		'dxDataGrid-exportAll': 'Bütün məlumatları ixrac edin',
		'dxDataGrid-headerFilterEmptyValue': '(Blanks)',
		'dxDataGrid-headerFilterOK': 'Oldu',
		'dxDataGrid-headerFilterCancel': 'Ləğv et',
		'dxDataGrid-ariaColumn': 'Sütun',
		'dxDataGrid-ariaValue': 'Data',
		'dxDataGrid-ariaFilterCell': 'Filtr hüceyrəsi',
		'dxDataGrid-ariaCollapse': 'Çökmək',
		'dxDataGrid-ariaExpand': 'Genişlet',
		'dxDataGrid-ariaDataGrid': 'Tablo',
		'dxDataGrid-ariaSearchInGrid': 'Cədvəldə axtarın',
		'dxDataGrid-ariaSelectAll': 'Hamısını seç',
		'dxDataGrid-ariaSelectRow': 'Sıra seçin',
		'dxDataGrid-filterBuilderPopupTitle': 'Filtr Generatoru',
		'dxDataGrid-filterPanelCreateFilter': 'Filtr Yaradın',
		'dxDataGrid-filterPanelClearFilter': 'Sil',
		'dxDataGrid-filterPanelFilterEnabledHint': 'Filtri aktivləşdirin',
		'dxTreeList-ariaTreeList': 'Ağac siyahısı',
		'dxTreeList-editingAddRowToNode': 'əlavə et',
		'dxPager-infoText': 'Sayfa {0} / {1} ({2} veri)',
		'dxPager-pagesCountText': 'arasında',
		'dxPager-pageSizesAllText': 'Hamısı',
		'dxPivotGrid-grandTotal': 'Ümumi cəmi',
		'dxPivotGrid-total': '{0} Ümumi',
		'dxPivotGrid-fieldChooserTitle': 'Sahə Seçicisi',
		'dxPivotGrid-showFieldChooser': 'Sahə Seçicisini göstərin',
		'dxPivotGrid-expandAll': 'Bütün genişləndirmək',
		'dxPivotGrid-collapseAll': 'Hamısını yığışdırın',
		'dxPivotGrid-sortColumnBySummary': '"{0}" Bu Sütun üzrə Sırala',
		'dxPivotGrid-sortRowBySummary': '"{0}" Bu Cərgəyə Görə Çeşidləyin',
		'dxPivotGrid-removeAllSorting': 'Bütün Reytinqləri Sil',
		'dxPivotGrid-dataNotAvailable': 'N/A',
		'dxPivotGrid-rowFields': 'Sıra Sahələri',
		'dxPivotGrid-columnFields': 'Sütun Sahələri',
		'dxPivotGrid-dataFields': 'Məlumat Sahələri',
		'dxPivotGrid-filterFields': 'Filtr Sahələri',
		'dxPivotGrid-allFields': 'Bütün Sahələr',
		'dxPivotGrid-columnFieldArea': 'Sütun Sahələrini Bura buraxın',
		'dxPivotGrid-dataFieldArea': 'Məlumat sahələrini bura buraxın',
		'dxPivotGrid-rowFieldArea': 'Satır Sahələrini Bura buraxın',
		'dxPivotGrid-filterFieldArea': 'Filtr Sahələrini Bura Buraxın',
		'dxScheduler-editorLabelTitle': 'Mövzu',
		'dxScheduler-editorLabelStartDate': 'Başlama Tarixi',
		'dxScheduler-editorLabelEndDate': 'Bitmə Tarixi',
		'dxScheduler-editorLabelDescription': 'İzahat',
		'dxScheduler-editorLabelRecurrence': 'Yenidən',
		'dxScheduler-openAppointment': 'Vədələşmək',
		'dxScheduler-recurrenceNever': 'Heç vaxt',
		'dxScheduler-recurrenceMinutely': 'Minutely',
		'dxScheduler-recurrenceHourly': 'Hourly',
		'dxScheduler-recurrenceDaily': 'Gündəlik',
		'dxScheduler-recurrenceWeekly': 'Həftəlik',
		'dxScheduler-recurrenceMonthly': 'Aylıq',
		'dxScheduler-recurrenceYearly': 'İllik',
		'dxScheduler-recurrenceRepeatEvery': 'Hər təkrar',
		'dxScheduler-recurrenceRepeatOn': 'Təkrarlamaq',
		'dxScheduler-recurrenceEnd': 'Təkrarla bitir',
		'dxScheduler-recurrenceAfter': 'Sonra',
		'dxScheduler-recurrenceOn': 'ilə',
		'dxScheduler-recurrenceRepeatMinutely': 'minute(s)',
		'dxScheduler-recurrenceRepeatHourly': 'hour(s)',
		'dxScheduler-recurrenceRepeatDaily': 'günlər',
		'dxScheduler-recurrenceRepeatWeekly': 'həftələr',
		'dxScheduler-recurrenceRepeatMonthly': 'aylar',
		'dxScheduler-recurrenceRepeatYearly': 'illər',
		'dxScheduler-switcherDay': 'Gün',
		'dxScheduler-switcherWeek': 'Həftə',
		'dxScheduler-switcherWorkWeek': 'İş həftəsi',
		'dxScheduler-switcherMonth': 'Ay',
		'dxScheduler-switcherAgenda': 'Gündəm',
		'dxScheduler-switcherTimelineDay': 'Zaman Qrafiki Günü',
		'dxScheduler-switcherTimelineWeek': 'Timeline Həftəsi',
		'dxScheduler-switcherTimelineWorkWeek': 'Cədvəl İş Həftəsi',
		'dxScheduler-switcherTimelineMonth': 'İş qrafiki',
		'dxScheduler-recurrenceRepeatOnDate': 'tarihinde',
		'dxScheduler-recurrenceRepeatCount': 'hadisələr',
		'dxScheduler-allDay': 'Bütün gün',
		'dxScheduler-confirmRecurrenceEditMessage':
			'Yalnız bu görüşü və ya bütün seriyanı redaktə etmək istəyirsiniz?',
		'dxScheduler-confirmRecurrenceDeleteMessage':
			'Yalnız bu görüşü və ya bütün seriyanı silmək istəyirsiniz?',
		'dxScheduler-confirmRecurrenceEditSeries': 'Serialı redaktə edin',
		'dxScheduler-confirmRecurrenceDeleteSeries': 'Seriyasını silin',
		'dxScheduler-confirmRecurrenceEditOccurrence': 'Görüşü redaktə edin',
		'dxScheduler-confirmRecurrenceDeleteOccurrence': 'Görüşü silin',
		'dxScheduler-noTimezoneTitle': 'Saat qurşağı yoxdur',
		'dxScheduler-moreAppointments': '{0} daha',
		'dxCalendar-todayButtonText': 'Bu gün',
		'dxCalendar-ariaWidgetName': 'Təqvim',
		'dxColorView-ariaRed': 'Qırmızı',
		'dxColorView-ariaGreen': 'Yaşıl',
		'dxColorView-ariaBlue': 'Mavi',
		'dxColorView-ariaAlpha': 'Şəffaflıq',
		'dxColorView-ariaHex': 'Rəng kodu',
		'dxTagBox-selected': '{0} seçildi',
		'dxTagBox-allSelected': 'Hamısı seçildi ({0})',
		'dxTagBox-moreSelected': '{0} daha',
		'vizExport-printingButtonText': 'Çap et',
		'vizExport-titleMenuText': 'İxrac/Çap',
		'vizExport-exportButtonText': '{0} fayl',
		'dxFilterBuilder-and': 'Və',
		'dxFilterBuilder-or': 'Və ya',
		'dxFilterBuilder-notAnd': 'Yox Və',
		'dxFilterBuilder-notOr': 'Yox Və ya',
		'dxFilterBuilder-addCondition': 'Şərt əlavə edin',
		'dxFilterBuilder-addGroup': 'Qrup əlavə edin',
		'dxFilterBuilder-enterValueText': '<değer gir>',
		'dxFilterBuilder-filterOperationEquals': 'bərabərdir',
		'dxFilterBuilder-filterOperationNotEquals': 'Bərabər deyil',
		'dxFilterBuilder-filterOperationLess': 'Daha kiçik',
		'dxFilterBuilder-filterOperationLessOrEquals': 'Az və ya bərabərdir',
		'dxFilterBuilder-filterOperationGreater': 'Daha böyük',
		'dxFilterBuilder-filterOperationGreaterOrEquals': 'Daha böyük və ya bərabərdir',
		'dxFilterBuilder-filterOperationStartsWith': 'İlə başlayır',
		'dxFilterBuilder-filterOperationContains': 'Daxildir',
		'dxFilterBuilder-filterOperationNotContains': 'Daxil deyil',
		'dxFilterBuilder-filterOperationEndsWith': 'İlə bitir',
		'dxFilterBuilder-filterOperationIsBlank': 'Boş',
		'dxFilterBuilder-filterOperationIsNotBlank': 'Boş deyil',
		'dxFilterBuilder-filterOperationBetween': 'Arasında',
		'dxFilterBuilder-filterOperationAnyOf': 'Hər kəs',
		'dxFilterBuilder-filterOperationNoneOf': 'Heç biri',
		'dxHtmlEditor-dialogColorCaption': 'Şrift Rəngini dəyişdirin',
		'dxHtmlEditor-dialogBackgroundCaption': 'Fon Rəngini dəyişdirin',
		'dxHtmlEditor-dialogLinkCaption': 'Link əlavə edin',
		'dxHtmlEditor-dialogLinkUrlField': 'URL',
		'dxHtmlEditor-dialogLinkTextField': 'Mətn',
		'dxHtmlEditor-dialogLinkTargetField': 'Linki yeni pəncərədə açın',
		'dxHtmlEditor-dialogImageCaption': 'Şəkil əlavə edin',
		'dxHtmlEditor-dialogImageUrlField': 'URL',
		'dxHtmlEditor-dialogImageAltField': 'Alternativ mətn',
		'dxHtmlEditor-dialogImageWidthField': 'Genişlik (px)',
		'dxHtmlEditor-dialogImageHeightField': 'Hündürlük (px)',
		'dxHtmlEditor-dialogInsertTableRowsField': '!TODO',
		'dxHtmlEditor-dialogInsertTableColumnsField': '!TODO',
		'dxHtmlEditor-dialogInsertTableCaption': '!TODO',
		'dxHtmlEditor-heading': 'Başlıq',
		'dxHtmlEditor-normalText': 'Müntəzəm mətn'
	}
};

export default azMessages;
